module.exports = __webpack_public_path__ + "img/nyk-header-logo-transparent.c79f23ff.svg";